// extracted by mini-css-extract-plugin
export default {"root":"style_root__DEMFg","icon":"style_icon__Vau9Z"};